// explainFlowPayload — E-001: pure transformation från WorkflowState till
// ai-flow-explain-edge-fn:ens JSON-format. Separerad från hook:en så
// enhetstester kan importera utan att dra in Supabase-klienten.

import type { WorkflowBlock, Connector, BlockGroup } from '@/types/workflow';

export interface FlowStepDescription {
  blockId: string;
  text: string;
}

export interface ExplainFlowInput {
  name?: string;
  blocks: WorkflowBlock[];
  connectors: Connector[];
  groups: BlockGroup[];
  language?: 'sv' | 'en';
}

export function buildPayload(input: ExplainFlowInput) {
  return {
    state: {
      name: input.name,
      blocks: input.blocks.map((b) => ({
        id: b.id,
        type: b.type,
        name: b.config.name,
        description: b.config.description,
      })),
      connectors: input.connectors.map((c) => ({
        fromId: c.fromId,
        toId: c.toId,
        label: c.label,
      })),
      groups: input.groups.map((g) => ({
        id: g.id,
        name: g.name,
        blockIds: g.blockIds,
      })),
    },
    language: input.language ?? 'sv',
  };
}
